import { render, staticRenderFns } from "./AiChat.vue?vue&type=template&id=2fd2366c&scoped=true&"
import script from "./AiChat.vue?vue&type=script&lang=ts&"
export * from "./AiChat.vue?vue&type=script&lang=ts&"
import style0 from "./AiChat.vue?vue&type=style&index=0&id=2fd2366c&prod&scoped=true&lang=css&"
import style1 from "./AiChat.vue?vue&type=style&index=1&id=2fd2366c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2366c",
  null
  
)

export default component.exports